var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"context",staticClass:"context-menu",style:(_vm.style),attrs:{"tabindex":"0"},on:{"blur":_vm.close}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }